import React from "react";
import { FaHome } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

const NoPropertiesFound = () => {
//   const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center text-center py-20">
      {/* Icon */}
      <div className="bg-blue-100 text-blue-600 rounded-full p-6 mb-6">
        <FaHome className="text-4xl" />
      </div>

      {/* Heading */}
      <h2 className="text-2xl font-semibold mb-2 text-gray-800">
        You haven't posted any properties yet
      </h2>

      {/* Description */}
      <p className="text-gray-500 mb-6 max-w-sm">
        Start showcasing your listings today — post a property to see it appear
        here.
      </p>

      {/* CTA Button
      <button
        onClick={() => navigate("/admin/properties/add")}
        className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow transition-all duration-200"
      >
        Post Property
      </button> */}
    </div>
  );
};

export default NoPropertiesFound;
